import { useQuery } from 'hooks/useCustomQuery';
import getOperatorConnectUsages from '@/API/Company/getOperatorConnectUsages';

const useGetOperatorConnectUsages = (
    companyId,
    accountScope,
    enabled = true,
) => {
    return useQuery({
        queryKey: ['operatorConnectUsages', companyId, accountScope],
        queryFn: () => getOperatorConnectUsages(companyId, accountScope),
        refetchOnWindowFocus: false,
        staleTime: 10 * 60 * 1000, // 10 minutes
        enabled,
    });
};

export default useGetOperatorConnectUsages;
